<template>
  <div class="QrCode"
       id="wechat-qrcode"
       style="width: 180px; height: 180px"
       v-loading="codeImgLoading">
    <img v-if="!codeImgLoading && !codeErr"
         :src="codeImgUrl"
         style="width: 180px; height: 180px"
         alt="">
    <div v-if="codeErr"
         style="width: 180px; height: 180px;color: red;font-size: 16px;margin-left: 20px;padding-top: 30px">
      <p>请求报错</p>
      <p style="margin-top: -10px">请刷新重试</p>
    </div>
  </div>
</template>


<script>
import { getUserCode } from '@/api/user'
import { getObjFromUrl, isProductionEnvironment } from '@/utils'
export default {
  name: '',
  data() {
    return {
      codeImgUrl: '',
      codeImgLoading: false,
      codeErr: false,
    }
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {},
  methods: {},
  created() {},
  mounted() {
    let isPcLogin = true
    let service_url =
      'ai-test/app?homeInputValue=' + this.$store.state.user.homeInputValue
    //var u1 = new URL(service_url);
    //var domain = u1 ? u1.host : "radar.mktindex.com";
    $('.qrcode-login-options').click(function () {
      changeLogin()
    })
    function changeLogin() {
      if (isPcLogin) {
        isPcLogin = false
        $('.switch-icon').attr('src', './qrCode.png')
        $('.pcLogin').hide()
        $('.QrCodeLogin').show()
        $('.qrcode-login-options').text('魔镜账号登录')
        var obj = new WxLogin({
          id: 'wechat-qrcode', // 二维码容器的ID
          appid: 'wx304d5078be28b171', // 替换为您的AppID
          scope: 'snsapi_login',
          redirect_uri:
            'https://radar.mktindex.com/api/wechat_login?service=' +
            encodeURIComponent(service_url), // 替换为您的回调URL
          state: '3d6be0a4035d839573b04816624a415e',
          href: 'data:text/css;base64,aW1wb3dlckJveCB7d2lkdGg6IDE4MHB4O30KLmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDE4MHB4O2hlaWdodDoxODBweDttYXJnaW46MH0KLmltcG93ZXJCb3ggLnRpdGxlIHtkaXNwbGF5OiBub25lO30KLmltcG93ZXJCb3ggLmluZm8ge2Rpc3BsYXk6IG5vbmU7fQouc3RhdHVzX2ljb24ge2Rpc3BsYXk6IG5vbmV9Ci5pbXBvd2VyQm94IC5zdGF0dXMge3RleHQtYWxpZ246IGNlbnRlcjt9Cg==',
        })
      } else {
        isPcLogin = true
        $('.pcLogin').show()
        $('.QrCodeLogin').hide()
        $('.qrcode-login-options').text('微信扫码登录')
      }
    }
    this.codeImgLoading = true
    this.codeErr = false
    const browserFinger = localStorage.getItem('browserFinger')
    let query = getObjFromUrl(window.location.hash)
    const params = { browser_finger: browserFinger }
    if (query.f) {
      params.source = query.f
    }
    let url = ''
    const currentDomain = window.location.hostname
    if (isProductionEnvironment()) {
      url = 'https://radar.mktindex.com/api/wxacodeunlimit'
    } else {
      url = 'https://radartest.mktindex.com/api/wxacodeunlimit'
    }
    //only show wechat login for radar free user
    getUserCode(url, params)
      .then((res) => {
        this.codeImgLoading = false
        this.codeErr = false
        if (res.status == 'ok') {
          const result = res.result
          this.codeImgUrl = result.url
          this.$emit('changeScene', result.scene)
        }
      })
      .catch((err) => {
        this.codeImgLoading = false
        this.codeErr = true
      })
    // changeLogin()
  },
  watch: {
    dialogVisible: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.codeImgUrl = ''

          this.codeImgLoading = true
          this.codeErr = false
          const browserFinger = localStorage.getItem('browserFinger')
          let query = getObjFromUrl(window.location.hash)
          const params = { browser_finger: browserFinger }
          if (query.f) {
            params.source = query.f
          }
          //only show wechat login for radar free user
          let url = ''
          const currentDomain = window.location.hostname
          if (isProductionEnvironment()) {
            url = 'https://radar.mktindex.com/api/wxacodeunlimit'
          } else {
            url = 'https://radartest.mktindex.com/api/wxacodeunlimit'
          }
          getUserCode(url, params)
            .then((res) => {
              this.codeImgLoading = false
              this.codeErr = false
              if (res.status == 'ok') {
                const result = res.result
                this.codeImgUrl = result.url
                this.$emit('changeScene', result.scene)
              }
            })
            .catch((err) => {
              this.codeImgLoading = false
              this.codeErr = true
            })
        }
      },
    },
  },
  beforeDestroyed() {},
}
</script>

<style lang="less" scoped>
</style>
